// extracted by mini-css-extract-plugin
export default {"popup":"Popup_popup__DDMD3","popupInner":"Popup_popupInner__3kpbC","closeBtn":"Popup_closeBtn__btzVv"};